enum PaymentType {
  CASH = 'cash',
  CHECK = 'check',
  CREDIT = 'credit',
  WIRE = 'wire',
  APP = 'app',
  CRYPTO = 'crypto',
  UNKNOWN = 'unknown',
}

export default PaymentType;
